import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import TokenService from "../../api/services/TokenService";
import api from "../../api/api";
import {
  PERMISSION_DENIED_ACCEPT_INVITE,
  INVALID_INPUT,
} from "../../api/codes";
import { APIStandardError } from "../../types";
import { AUTH_TOKEN } from "../../api/queryKeys";

export default function useLogin({
  onSuccessHandler,
}: {
  onSuccessHandler?: () => void;
}) {
  return useMutation(
    ({
      email,
      password,
      new_password,
    }: {
      email: string;
      password: string;
      new_password?: string;
    }) =>
      api
        .post(AUTH_TOKEN, { username: email, password, new_password })
        .then((res) => res.data),
    {
      onError: (error: AxiosError) => {
        const errorData = error.response?.data as APIStandardError;
        switch (errorData.code) {
          case PERMISSION_DENIED_ACCEPT_INVITE:
            toast.error(errorData.detail);
            break;
          case INVALID_INPUT:
            if (errorData.non_field_errors) {
              toast.error(errorData.non_field_errors[0]);
              break;
            } else {
              toast.error("Unable to log in. Please try again.");
              break;
            }
          default:
            toast.error("Unable to log in. Please try again.");
            break;
        }
      },
      onSuccess: (data) => {
        TokenService.storeAuthTokensInLocalStorage(data.access, data.refresh);
        if (onSuccessHandler) {
          onSuccessHandler();
        }
      },
    }
  );
}
